import { Button, styled } from '@tools/wr-catalog-base'

export const ImgContainer = styled.div`
  width: 2em;
  height: 2em;
  margin: -0.5em;
`

export const StyledButton = styled(Button)`
  padding: 0.8rem 1rem !important;
`
